var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-menu",class:_vm.position},[_c('font-awesome-icon',{attrs:{"icon":['fa','caret-down']}}),_c('div',{staticClass:"bg"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }